<div class="container my-5">
    <h1 class="container text-center mt-3">Patrocinios</h1>
    <hr class="my-5">

    <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
            <img src="assets/img/wfoto01.jpg" height="50" alt="Grupo de personas alrededor de una fuente" class="img-fluid">
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
            <p class="p-em text-center">"Donde termina el pavimento, comienza nuestra misión. En la Red de Congregaciones de Hermanas Católicas, creemos que la salud es un derecho humano, no un privilegio. Desde 2024, unimos fuerzas para llevar medicina, prevención y esperanza a las familias que el sistema de salud ha olvidado en la Ciudad de México y el Estado de México. Tu generosidad es el puente que permite que un niño respire mejor, que una madre viva sin dolor y que un abuelo reciba la atención que merece. Únete a la Red de Vida."</p>
        </div>
    </div>
    
    <h2 class="text-center mt-5 mb-3">¿Por qué donar?</h2>
    <p class="p-em text-center">"En México, más de 44 millones de personas viven sin seguro de salud. En las comunidades rurales que atendemos, el gasto de bolsillo en una emergencia médica puede significar la pérdida de todo el patrimonio familiar. La Red no solo cura enfermedades; previene la pobreza. Al donar, estás invirtiendo en un modelo de atención primaria que ha demostrado reducir la mortalidad y mejorar la calidad de vida de los más desfavorecidos. Somos transparencia, somos fe, somos salud para todos."</p>
    
    <div class="contenedor-card">
        <div class="card mt-5">
        <h3 class="text-center">Simulador de Impacto</h3>
        <p class="text-center">Descubre lo que tu aportación mensual puede lograr.</p>
        
        <div class="amount-row">
            <div class="d-flex justify-content-between">
            <span>Aportación Mensual: </span>
            <span class="amount-value">${{ monto | number }} MXN</span>
        </div>
    </div>
    
    <input type="range" min="100" max="5000" step="100" [(ngModel)]="monto" (input)="actualizarSimulador()"/>

    <div class="range-labels">
        <div class="d-flex justify-content-between">
            <span>$100</span>
            <span>$5,000+</span>
        </div>
    </div>

    <div class="results row mt-3 text-center">
        
        <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="result-box">
                <span class="emojinx">💊</span>
                <p class="amount-slider-big mt-3"><span>{{ tratamientos }}</span></p>
                <p>Tratamientos Básicos</p>
            </div>
        </div>

        <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="result-box">
                <span class="emojinx">🩺</span>
                <p class="amount-slider-big mt-3"><span>{{ consultas }}</span></p>
                <p>Consultas Médicas</p>
            </div>
        </div>

        <div class="col-sm-4 col-md-4 col-lg-4">
            <div class="result-box">
                <span class="emojinx">📚</span>
                <p class="amount-slider-big mt-3"><span>{{ educacion }}</span></p>
                <p>Personas Educadas</p>
            </div>
        </div>
    
    </div>
    
    <div class="d-flex justify-content-center mt-3">
        <button class="mt-4">Donar y hacerlo realidad</button>
    </div>
    
    
    
    <p class="p-note mt-2 text-center">*Cálculo basado en costos operativos reales por servicio.</p>
    </div>

</div>

<br class="mb-5">